module.exports = __webpack_public_path__ + "img/details_top01.a6c7b3ea.png";